let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e3NHp")).then(() => parcelRequire('9K9Yj'));